import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { Modal, Button, Spinner } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import { useTohonBuy } from "../../context/TohonBuyContext";
import { TOHON_PENDING_STORAGE_KEY } from "../../utils/Util";

const PaymentSuccessOverlay = () => {
  const [show, setShow] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  // 'subscription'（サブスク）| 'tohon'（謄本購入）
  const [mode, setMode] = useState(null);
  const { clearTohon } = useTohonBuy();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const sessionId = query.get("session_id");
    const tohonResult = query.get("tohon_result");

    if (tohonResult === "success") {
      // 謄本購入：オーソリ（受付）完了
      setMode("tohon");
      setShow(true);

      // 二重購入防止：購入リストと一時保存をクリアする
      clearTohon();
      try {
        sessionStorage.removeItem(TOHON_PENDING_STORAGE_KEY);
      } catch (e) {
        // noop
      }

      // クエリのみ削除し、地図位置（hash）は残す（リロード時に再度開かないため）
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash
      );
    } else if (sessionId) {
      // サブスクリプション：決済成功時（既存処理）
      setMode("subscription");
      setShow(true);

      // ブラウザのURLからパラメータを削除（リロード時に再度開かないようにするため）
      window.history.replaceState({}, document.title, window.location.pathname);

      // 内部ステータス（Cognito属性）を最新化する
      refreshUserStatus();
    }
  }, [clearTohon]);

  const refreshUserStatus = async () => {
    setIsUpdating(true);
    try {
      // キャッシュを無視して最新の属性を取得し、AuthContextなどを更新させる
      await Auth.currentAuthenticatedUser({ bypassCache: true });

      // Webhookの反映に時差がある場合を考慮し、少し待ってから再度取得（念のため）
      await new Promise((resolve) => setTimeout(resolve, 2000));
      await Auth.currentAuthenticatedUser({ bypassCache: true });
    } catch (e) {
      console.error("ステータス更新エラー:", e);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="md"
      backdrop="static" // 枠外クリックで閉じないようにして確実にメッセージを見せる
      keyboard={false}
    >
      <Modal.Body className="text-center p-5">
        {mode === "tohon" ? (
          // 謄本購入：受付完了メッセージ
          <>
            <CheckCircleFill size={80} color="#28a745" className="mb-4" />
            <h3 className="fw-bold mb-3">
              ご注文
              <br />
              ありがとうございます
            </h3>
            <p className="text-muted mb-4" style={{ lineHeight: "1.8" }}>
              不動産登記情報（土地）のご注文を受け付けました。
              <br />
              登記情報は、ご登録のメールアドレスへ
              <br />
              メールの添付ファイル（PDF）として送付いたします。
              <br />
              <span style={{ fontSize: "0.9rem" }}>
                （オンライン決済の受付から送付まで15分程度かかります）
              </span>
            </p>
            <div className="d-grid">
              <Button
                variant="primary"
                size="lg"
                onClick={handleClose}
                className="fw-bold shadow-sm"
              >
                地図に戻る
              </Button>
            </div>
          </>
        ) : isUpdating ? (
          <div className="py-4">
            <Spinner animation="border" variant="primary" className="mb-3" />
            <p className="text-muted">お申込み情報を確認しています...</p>
          </div>
        ) : (
          // サブスクリプション：登録完了メッセージ（既存）
          <>
            <CheckCircleFill size={80} color="#28a745" className="mb-4" />
            <h3 className="fw-bold mb-3">
              お申し込み
              <br />
              ありがとうございます
            </h3>
            <p className="text-muted mb-4" style={{ lineHeight: "1.8" }}>
              サブスクリプションの登録が完了しました。
              <br />
              <strong>サブスクリプションの機能</strong>（地図印刷・画像作成等）が
              <br />
              今すぐご利用いただけます。
            </p>
            <div className="d-grid">
              <Button
                variant="primary"
                size="lg"
                onClick={handleClose}
                className="fw-bold shadow-sm"
              >
                さっそく使ってみる
              </Button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PaymentSuccessOverlay;
